import React from "react";
import NavUp from "../commons/NavUp";
import "../pages/Home/Component/Card.css";
import AllCards from "./Component/AllCards";
import firebaseManager from "../model/Firebase/FirebaseManager";
import DentsAvailable from "./Component/DentsAvailable";
import NavbarAdmin from "../commons/NavbarAdmin";


class Home_admin extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }


  render() {
    return (
      <React.Fragment>
        <NavUp />
         <AllCards />
         <NavbarAdmin />
      </React.Fragment>
    );
  }
}
export default Home_admin;
